import React from 'react'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  root: {
    '& > *': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      margin: '0 auto',
      animation: 'typing 3.5s steps(40, end)'
    }
  }
})

const TypeWriter = ({ children }) => {
  const classes = useStyles()
  return <div className={classes.root}>{children}</div>
}

export default TypeWriter
